var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotAcceptedState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 73,
    viewBox: "0 0 150 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 25H80C82.2091 25 84 26.7909 84 29V69H24V25z",
    fill: "#d8ddeb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88 12h50c2.209.0 4 1.7909 4 4V69H88V12z",
    fill: "#d8ddeb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 29c0-2.2091 1.7909-4 4-4H60c2.2091.0 4 1.7909 4 4V69H9V29z",
    fill: "#eaeef4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73 16C73 13.7909 74.7909 12 77 12h47c2.209.0 4 1.7909 4 4V69H73V16z",
    fill: "#eaeef4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.397 1.68441C134.758-.56147 138.242-.56147 139.603 1.68441l9.935 16.39109C150.873 20.2783 149.158 23 146.434 23H126.566C123.843 23 122.127 20.2783 123.462 18.0755L133.397 1.68441zM138.28 18.0435C138.28 18.956 137.483 19.6957 136.5 19.6957S134.72 18.956 134.72 18.0435C134.72 17.1309 135.517 16.3912 136.5 16.3912S138.28 17.1309 138.28 18.0435zM136.5 4.8256c-.983000000000004.0-1.78.73974-1.78 1.65224V11.4345c0 .9125.796999999999997 1.6523 1.78 1.6523S138.28 12.347 138.28 11.4345V6.47784C138.28 5.56534 137.483 4.8256 136.5 4.8256z",
    fill: "url(#paint0_linear_2220_2246)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 69,
    width: 150,
    height: 4,
    rx: 2,
    fill: "#f5f8fa"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 40,
    width: 24,
    height: 14,
    rx: 4,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 43,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#d8ddeb"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 43,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#d8ddeb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 43,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#d8ddeb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 43,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#d8ddeb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 34,
    width: 24,
    height: 14,
    rx: 4,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 37,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#d8ddeb"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 37,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#d8ddeb"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 37,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#d8ddeb"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 37,
    width: 2,
    height: 8,
    rx: 1,
    fill: "#d8ddeb"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2220_2246",
    x1: 109.5,
    y1: 11.5,
    x2: 132.207,
    y2: 38.1566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00baff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007cff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAcceptedState);
export default __webpack_public_path__ + "static/media/not-accepted-state.7420942c.svg";
export { ForwardRef as ReactComponent };